import { selectors } from 'app-webtech-core';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { UI_LOADED } from './types';
import { appLoaded, setLaunchState } from '../../application/actions';
import { LAUNCH_STATE } from '../../application/constants';

const action = actionCreator(UI_LOADED);

export const uiLoadedThunkAction = () => (dispatch, getState) => { // eslint-disable-next-line no-unused-vars
  const state = getState();
  const { uiLoaded } = selectors.application.properties(state);
  if (!uiLoaded) {
    dispatch(action());
    dispatch(setLaunchState(LAUNCH_STATE.UI_LOADED));
    dispatch(appLoaded());
  }
};
